import { CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';
import Auth from '@aws-amplify/auth';
import { Hub, HubPayload } from '@aws-amplify/core';
import { environment } from '@ov-suite/helpers-shared';

export async function refreshSession(): Promise<CognitoUserSession> {
  return new Promise((resolve, reject) => {
    const userPool = new CognitoUserPool({
      UserPoolId: environment.values.cognito.userPoolId,
      ClientId: environment.values.cognito.clientId,
    });

    Auth.currentSession()
      .then(session => {
        if (session) {
          userPool.getCurrentUser().refreshSession(session.getRefreshToken(), (err, res) => {
            if (err) {
              reject(err);
            } else {
              const payload: HubPayload = {
                data: {},
                event: 'refresh',
                message: 'Token Refreshed',
              };
              Hub.dispatch('token', payload);
              resolve(res);
            }
          });
        }
      })
      .catch(reject);
  });
}
